import 'hiraku/js/jquery-hiraku.min';
import Alert from 'bootstrap/js/dist/alert';
// import 'modaal/dist/js/modaal.min';
import "./swiper";
import"../scss/style.scss";

//ロード完了 SP NAV表示
// $(window).on('load', function(){
//     $('.js-nav').css('display', 'block');
// });

/*==================================================

ページ内リンク
==================================================*/
$(window).on('load', function(){
    var screenWidth = window.innerWidth;
    var headerHight = 90;//ヘッダの高さ
    if (screenWidth >= 1400) {
        headerHight = 90;
    }else if(screenWidth <= 1401 && screenWidth >= 767) {
        headerHight = 80;
    }else if(screenWidth <= 768) {
        headerHight = 80;
    }
    $('a[href^="#"]:not(#js-notscroll)').on("click", function (event) {
        event.preventDefault();
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        var position = target.offset().top - headerHight; //ヘッダの高さ分位置をずらす
        $("html, body").animate({ scrollTop: position }, 450, "swing");
        return false;
    });
});

// header 追従 位置調整
// $(function () {
//     var windowWidth = $(window).width();
//     var windowSm = 991;
//     if (windowWidth > windowSm) {
//         $(window).on('scroll', function() {
//             let scrollTop = $(window).scrollTop(); // スクロール上部の位置
//             // let areaTop = $("#js-target-area").offset().top; // 対象エリアの上部の位置
//             // let areaBottom = areaTop + $("#js-target-area").innerHeight(); // 対象エリアの下部の位置

//             if (scrollTop  > 450) {
//                 $("#header").addClass("fixed__top"); // スクロールが対象エリアに入った場合
//             } else {
//                 $("#header").removeClass("fixed__top"); // スクロールが対象エリアから出ている場合
//             }
//         });
//     }
// });

// $(function () {
//     // var headH = $("header").outerHeight();
//     var headH = 0;
//     var animeSpeed = 150;
//     var urlHash = location.hash; //URLのハッシュタグを取得
//     if (urlHash) { //ハッシュタグが有る場合
//         $("body,html").scrollTop(0);
//         setTimeout(function () { //無くてもいいが有ると動作が安定する
//             var target = $(urlHash);
//             var position = target.offset().top - headH;
//             $("body,html").stop().animate({
//                 scrollTop: position
//             }, animeSpeed,"swing");
//         }, 0);
//     }
// });

// 別ページ アンカーリンク調整
// $(function(){
//     // var headerHeight = $('.site-header').outerHeight();
//     var headerHeight = 0;
//     var urlHash = location.hash;
//     if(urlHash) {
//         $('body,html').stop().scrollTop(0);
//         setTimeout(function(){
//             var target = $(urlHash);
//             var position = target.offset().top - headerHeight;
//             $('body,html').stop().animate({scrollTop:position}, 120,"swing");
//         }, 600);
//     }
//     $('a[href^="#"]:not(#js-notscroll)').on('click',function() {
//         var href= $(this).attr("href");
//         var target = $(href);
//         var position = target.offset().top - headerHeight;
//         $('body,html').stop().animate({scrollTop:position}, 120,"swing");
//     });
// });


// 現在表示しているページがTOPページか下層ページかによって処理を分岐
// $(function () {
//     // var headH = $("header").outerHeight();
//     var headH = 0;
//     var animeSpeed = 150;
//     var id = $("body").attr("id");
//     //グロナビアンカー
//     $(".nav_anc").on("click", function () {
//         var currentUrl = location.pathname; //URLのパス名を取得
//         var url1 = currentUrl.split("/"); //パスを「/」区切りで分割
//         var targetUrl = $(this).children("a").attr("href"); //リンク先のURLを取得（リンク先はルートパスで指定）
//         var url2 = targetUrl.split("/"); //リンク先URLを「/」区切りで分割
//         var target;
//         var position;
//         $(".pulldown").hide();
//         //現在地がTOPページの場合
//         if (id === "toppage") { //bodyにid「toppage」が有る場合
//             if (url2[1].match("^#")) {
//                 target = $(url2[1]);
//                 position = target.offset().top - headH;
//                 $("body,html").stop().animate({
//                     scrollTop: position
//                 }, animeSpeed);
//                 return false;
//             }
//         }
//         //現在地が下層ページの場合
//         if (url1[1] === url2[1]) { //それぞれ「/」で区切ったものの1つ目が一致した場合
//             target = $(url2[2]);
//             position = target.offset().top - headH;
//             $("body,html").stop().animate({
//                 scrollTop: position
//             }, animeSpeed);
//             return false;
//         }
//     });
// });

/*==================================================
アンカーリンク 別ページ
==================================================*/
// $(window).on('load', function() {
//     var url = $(location).attr('href');
//     if(url.indexOf("#") != -1){
//         var anchor = url.split("#");
//         var target = $('#' + anchor[anchor.length - 1]);
//         var screenWidth = window.innerWidth;
//         var offsetTop = 0;
//         if (screenWidth >= 1440) {
//             offsetTop = 0;
//         }else if(screenWidth <= 1441) {
//             offsetTop = 90;
//         }else if(screenWidth < 768) {
//             offsetTop = 60;
//         }
//         if(target.length){
//             var pos = Math.floor(target.offset().top) - offsetTop;
//             $("html, body").animate({scrollTop:pos}, 150);
//         }
//     }
// });

/**
 * div-link
 */
$(function(){
    $('.js-link').on("click",function(){
        location.href = $(this).attr('data-href');
    });
});


/**
//  * パララックススクロールテキスト
//  */
// //初期設定
// var $window = $(window),
//     wh = window.innerHeight,
//     nowScroll = $window.scrollTop(),
//     reg = -0.8;//調整値、負の数だとスクロール時に上に動き、正の数だと下に動く。絶対値が大きいほど動く量が小さくなる。

// $window.on('load resize', function () {
//     wh = window.innerHeight;
//     nowScroll = $window.scrollTop();
// });
// window.addEventListener('scroll', function () {
//     nowScroll = $window.scrollTop();
// }, { passive: true });

// //トリガー
// var $paraItem = $('#div1');
// if ($paraItem.length) {
//     parallax();
//     $window.on('load resize', parallax);
//     window.addEventListener('scroll', parallax);
// }

// //処理内容
// function parallax() {
//     $paraItem.each(function () {
//         var $this = $(this),
//         scroll_bottom = nowScroll + wh;
//         $this.css('transform', '');

//         var nowpos = $this.offset().top;
//         if (nowpos < scroll_bottom) {
//             $this.css('left', ( ((scroll_bottom - nowpos) / reg)+ 465 + 'px'));
//         }
//     });
// }


// /*
// * sp menu
// */
$('#nav__btn').on("click",function(){
    $('html').toggleClass('stop-scroll');
    $(this).toggleClass('active');
    $('#sp__nav').toggleClass('active');
});

//ウィンドウサイズ スクロール制限解除
$(function () {
    $(window).on('resize',function(){
        if($(window).width()>991){
            $('html').removeClass('stop-scroll');
        }
    });
});

$(function () {
    $(window).on('resize',function(){
        if($(window).width()<991){
            $("#header").removeClass("fixed__top");
        }
    });
});

// 100vh sp__nav ios対策
function setHeight() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
  // 初期化
setHeight();
  // ブラウザのサイズが変更された時・画面の向きを変えた時に再計算する
window.addEventListener('resize', setHeight);

/**
 * tab
 */
/*
$(function() {
    let tabs = $(".tab__trigger"); // .tab__triggerを全て取得し、変数tabsに配列で定義
    $(".tab__trigger").on("click", function() { // .tab__triggerをクリックしたらイベント発火
      $(".tab__trigger").removeClass("active"); // activeクラスを消す
      $(this).addClass("active"); // クリックした箇所にactiveクラスを追加
      const index = tabs.index(this); // クリックした箇所がタブの何番目か判定し、定数indexとして定義
      $(".contents").removeClass("show").eq(index).addClass("show"); // showクラスを消して、contentsのindex番目にshowクラスを追加
    })
})
*/

/**
 * hiraku
 */
// $(".offcanvas-right").hiraku({
//     btn:"#offcanvas-btn-right",
//     fixedHeader:".js-fixed-header",
//     direction:"right",
//     width: "50%"
// });



/**
 * modaal
 */
// $('.modaal').modaal({
//     background_scroll: false,
//     overlay_opacity: 0.7,
//     fullscreen: true
// });


/**
 * slidedown
 */
/*
$(function(){
	$('.header__nav ul li .link').hover(function(){
		if($(window).width() >= 992){
			$(this).find(".second__menu").stop().slideDown();
		}
	}, function(){
		$(this).find(".second__menu").stop().slideUp();
	});
});
$(function(){
    $('.dropdwn li').hover(function(){
        $("ul:not(:animated)", this).slideDown();
    }, function(){
        $("ul.dropdwn_menu",this).slideUp();
    });
});
*/
